import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
// import { Modal, Spin } from "antd";
// import { LoadingOutlined } from '@ant-design/icons';

export default function Logout() {
  const dispatch = useDispatch();
  // const mymodal = Modal.info({
  //   okButtonProps: { style: { visible: false, display: "none" } },
  //   closable: false,
  //   footer: null,
  //   title: "Logging you out..",
  //   content: (<>
  //     <Spin indicator={<LoadingOutlined />} />
  //   </>)
  // })
  useEffect(() => {
    // mymodal.destroy()
    window.location.replace("/")
    dispatch({ type: "sign_out" });
    // setTimeout(() => {
    //   setTimeout(() => {
    //   }, 500);
    // }, 3000);
  }, [dispatch]);
  return <></>
}
